import { useCropperStore } from "@src/v3.0.0/store/cropper/cropper-store";
import { Fade } from '@mui/material';
import PassThroughDiv from '../PassThroughDiv';
import { useFurnituresStore } from '@src/v3.0.0/store/furnitures/store';
import CropboxContainer from '../Cropper/CropboxContainer';
import { useEffect } from "react";
import { FurnitureDrawer } from "./FurnitureDrawer";
import { FurnitureObject } from "./FurnitureObject";
import { useCropperAction } from "@src/v3.0.0/store/cropper/cropper-actions";
import { useScreenToWorld } from "./use-screen-to-world";

export function Furnitures() {
  const cropperStore = useCropperStore();
  const {drawerIsShown, items, itemsVisible, getItemByName, addItem, empty: emptyTheStore } = useFurnituresStore();
  const cropperAction = useCropperAction();
  const screenToWorld = useScreenToWorld();

  useEffect(() => {
    if (cropperAction.action) {
      switch(Object.keys(cropperAction.action)[0]) {
        default: break;
        case 'zeroAll': return emptyTheStore();
      }
    }
  }, [cropperAction.action]);

  useEffect(() => {
    if (!cropperStore?.element?.cropper) {
      return;
    }

    if (drawerIsShown) {
      cropperStore.element.cropper.off();
    } else {
      cropperStore.element.cropper.on();
    }
  }, [drawerIsShown, cropperStore.element]);

  const onDragOver = e => {
    // allow drop on the area
    e.preventDefault();
  }

  const onDrop = e => {
    const furnitureName = e.dataTransfer.getData("furnitureName");
    const furniture = getItemByName(furnitureName);
    const pos = screenToWorld(e.clientX, e.clientY);
    // get the furniture object and add the item
    addItem(furniture, pos);
  }

  return (
    <>
      <Fade in={drawerIsShown || items.length > 0}>
        <PassThroughDiv position="absolute" pointer={drawerIsShown ? 'all' : 'none'}>
          <CropboxContainer 
            id="furnitures-root"
            onDrop={onDrop}
            onDragOver={onDragOver}
          >
            {itemsVisible && items.map((object, idx) => (
              <FurnitureObject key={idx} {...object}  />
            ))}
          </CropboxContainer>
        </PassThroughDiv>
      </Fade>
      <FurnitureDrawer />
    </>
  )
}